import EastRoundedIcon from '@mui/icons-material/EastRounded'
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'
import { Box } from '@mui/material'
import { useTranslate } from 'ra-core'
import { useRecordContext, required } from 'react-admin'

import { INCIDENT_REPORT_ACTION_UPDATE_SEVERITY } from '../../../config/damages'
import SeveritySelectInput, { IncidentSeverityField } from '../SeveritySelectInput'
import { ActionCommentSection, ActionModalSection, IncidentReportActionDialog, useActionSubmit } from './common'

export const UpdateSeverityFormDialog = ({ open, onClose }) => {
  const record = useRecordContext()
  const translate = useTranslate()
  const [submitAction, isLoading] = useActionSubmit(record.id, onClose)

  const onSubmitAction = (values) =>
    submitAction(
      INCIDENT_REPORT_ACTION_UPDATE_SEVERITY,
      {
        comment: values.comment || '',
        details: {
          severity: values.severity,
        },
      },
      'resources.incident-reports.actions.update_severity.success',
    )

  return (
    <IncidentReportActionDialog
      open={open}
      onClose={onClose}
      isLoading={isLoading}
      i18nPrefix="resources.incident-reports.actions.update_severity"
      formProps={{ defaultValues: { ...record, severity: '' }, mode: 'onChange' }}
      footerProps={{
        confirmLabelKey: 'resources.incident-reports.actions.update_severity.confirmLabel',
        transitionFieldName: 'severity',
        onSubmitAction,
      }}
    >
      <ActionModalSection
        title={translate('resources.incident-reports.fields.severity')}
        titleIcon={FactCheckOutlinedIcon}
        helperKey="resources.incident-reports.actions.update_severity.helperText"
        sx={{ mt: 0 }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) 28px minmax(0, 1fr)' },
            columnGap: 1.5,
            rowGap: 1.25,
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              height: 40,
              boxSizing: 'border-box',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              px: 1.25,
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'action.hover',
            }}
          >
            <IncidentSeverityField value={record.severity} />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', color: 'text.secondary' }}>
            <EastRoundedIcon sx={{ fontSize: 18 }} />
          </Box>
          <Box
            sx={{
              height: 56,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              '& .MuiFormControl-root': { width: '100%', m: 0 },
            }}
          >
            <SeveritySelectInput excludeValues={[record.severity]} validate={required()} />
          </Box>
        </Box>
      </ActionModalSection>
      <ActionCommentSection />
    </IncidentReportActionDialog>
  )
}
